import { render, staticRenderFns } from "./AffiliateReportsSales.vue?vue&type=template&id=7a46d805&"
import script from "./AffiliateReportsSales.vue?vue&type=script&lang=js&"
export * from "./AffiliateReportsSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports